$(function () {
    var submitBtn = $('.header__search').find('.form-control-submit');
    var textInput = submitBtn.siblings('input[type="text"]');

    submitBtn.click(function (e) {
        e.preventDefault();
        textInput.toggleClass('expanded');

        submitBtn.toggleClass('bi-search');
        submitBtn.toggleClass('bi-x-lg');
    });

    $(document).on('click', function (e) {
        if ($(e.target).is(submitBtn) === false && $(e.target).is(textInput) === false && textInput.length == 0 && textInput.hasClass('expanded')) {

            textInput.removeClass('expanded');

            submitBtn.toggleClass('bi-search');
            submitBtn.toggleClass('bi-x-lg');
        }
    });

    $('#btnLoadMoreSearchResults').on('click', '.btn', function (e) {
        e.preventDefault();
        var searchResultsContainer = $(this).parent().siblings('.search-items').find('.was-hidden').first();

        searchResultsContainer.removeClass('was-hidden');
        searchResultsContainer.addClass('loaded');

        var hiddenRowsRemaining = $(this).parent().siblings('.search-items').find('.was-hidden');
        if (hiddenRowsRemaining.length <= 0) {
            $('#btnLoadMoreSearchResults').css('display', 'none');
        }
    });
});